import {
  SEND_LEAVE_REQUEST,
  SEND_LEAVE_REQUEST_FAIL,
  SEND_LEAVE_REQUEST_SUCCESS,
} from "./actionType";

// send leave request
export const sendLeaveRequest = (data) => ({
  type: SEND_LEAVE_REQUEST,
  payload: data,
});

export const sendLeaveRequestSuccess = (data) => ({
  type: SEND_LEAVE_REQUEST_SUCCESS,
  payload: data,
});

export const sendLeaveRequestFail = (data) => ({
  type: SEND_LEAVE_REQUEST_FAIL,
  payload: data,
});
